<template>
  <div
    class="form-fw__header"
    :class="{ 'form-fw__header--shadow': shadow }"
  >
    <header>
      <v-layout align-center justify-start row>
        <v-flex xs2 md3>
          <v-btn class="mx-0" flat icon @click="prevPage">
            <v-icon color="gray-6">arrow_back</v-icon>
          </v-btn>
        </v-flex>

        <v-flex xs8 md6>
          <div class="text-xs-center">
            <h1 class="form-fw__header__title">
              {{
                kind === 'editar'
                  ? $t(`${namespace}.editRideCredit`)
                  : $t(`${namespace}.addRideCredit`)
              }}
            </h1>
          </div>
        </v-flex>

        <v-flex xs2 md3>
          <div
            v-if="kind !== 'editar'"
            class="text-xs-right pr-2 hidden-xs-only hidden-sm-only"
          >
            <strong>{{ $t(`${namespace}.didNotFindArace`) }}</strong><br>
            <span>
              {{ $t(`${namespace}.searchForYourIdIn`) }}
              <router-link
                :to="{ name: 'FinancialAdjustments' }"
                :title="$t(`${namespace}.reports`)"
                class="accent--text"
              >

                {{ $t(`${namespace}.reports`) }}
              </router-link>
            </span>
          </div>
        </v-flex>
      </v-layout>
    </header>

    <transition name="fade">
      <v-progress-linear
        v-if="status === isLoading"
        color="accent"
        class="pa-0 ma-0"
        height="3"
        indeterminate
      />
    </transition>
  </div>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { goBack } from '@/utils/functions'

export default {
  name: 'EmployeeHeader',
  props: {
    kind: {
      type: String
    },
    status: {
      type: Number
    }
  },
  computed: {
    isLoading: () => STATUS_IS_LOADING,
    isSuccess: () => STATUS_SUCCESS,
    isFailed: () => STATUS_FAILED
  },
  data () {
    return {
      namespace: 'Views.RideCreditPage',
      shadow: false
    }
  },
  methods: {
    prevPage () {
      goBack()
    },

    handleShadow () {
      this.shadow = window.scrollY > 0
    }
  },
  mounted () {
    this.handleShadow()
    window.addEventListener('scroll', this.handleShadow)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleShadow)
  }
}
</script>
